angular.module('impactx.tax').controller('CC2TaxEventDialogCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    'TranslationService',
    'ToolbarService',
    CC2TaxEventDialogCtrl
]);

function CC2TaxEventDialogCtrl($scope, dataGen, BackService, ToastService, TranslationService, ToolbarService) {
    var ctrl = this;

    $scope.regionAdditionalData = [];
    $scope.taxEventAdditionalData = [];
    $scope.regionControl = {};
    $scope.taxEventControl = {};

    var resetSelectArray = function () {
        $scope.regionAdditionalData = [];
        $scope.taxEventAdditionalData = [];
    };

    ctrl.getData = function () {
        dataGen.getData($scope, {}, '/tax/cc2taxevent/new').then(function () {
            defineButtons();
        });
    };

    ctrl.save = function () {
        var paramObj = {
            data: $scope.data
        };
        return dataGen.postAsForm({}, paramObj, '/tax/cc2taxevent/save').then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.regionSelected = function (selected) {
        resetSelectArray();
        $scope.taxEventAdditionalData.push({field: 'rgnId', value: selected ? selected.id : 0});
        if (!$scope.data.taxEvent.selected && selected) {
            $scope.taxEventControl.getEntries($scope.taxEventAdditionalData, true);
        }
    };

    ctrl.taxEventSelected = function (selected) {
        resetSelectArray();
        $scope.regionAdditionalData.push({field: 'taxEventId', value: selected ? selected.id : 0});
        if (!$scope.data.region.selected && selected) {
            $scope.regionControl.getEntries($scope.regionAdditionalData, true);
        }
    };

    ctrl.getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: ctrl.save,
                type: 'validation',
                params: {form: $scope.dialogData}
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}